import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '@tdwb/core';

import { FplOnLoanComponent } from './fpl-on-loan/fpl-on-loan.component';
import { FplRecallSecurityComponent } from './recall-security/fpl-recall-security.component';
import { FplRestService } from './services/fpl-rest.service';
import { StockLendingService } from './services/stock-lending.service';
import { FplTermsAndConditionsComponent } from './fpl-terms-and-conditions/fpl-terms-and-conditions.component';
import { FplIntroductionComponent } from './fpl-introduction/fpl-introduction.component';
import { FplFaqComponent } from './fpl-faq/fpl-faq.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    FormsModule,
    CoreModule,
    FplOnLoanComponent,
    FplRecallSecurityComponent,
    FplTermsAndConditionsComponent,
    FplIntroductionComponent,
    FplFaqComponent
  ],
  providers: [
    FplRestService
  ],
  exports: [
    FplOnLoanComponent,
    FplRecallSecurityComponent,
    FplTermsAndConditionsComponent,
    FplIntroductionComponent,
    FplFaqComponent
  ]
})
export class WebbrokerFplCommonModule {}

export {
  FplOnLoanComponent,
  FplRecallSecurityComponent,
  FplRestService,
  FplTermsAndConditionsComponent,
  StockLendingService
};
